import { render, staticRenderFns } from "./CategoryEditPopup.vue?vue&type=template&id=34b129f1&"
import script from "./CategoryEditPopup.vue?vue&type=script&lang=js&"
export * from "./CategoryEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEditPopup.vue?vue&type=style&index=0&id=34b129f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports